import React from "react";
import styled from "styled-components";
import { ZIndexes, background, content, cover, transparentize } from "@glossy";
import { tr } from "@linkfluence/i18n";
import { Locale } from "@linkfluence/models/locale";
import Dots from "@ui-kit/loader/dots";

interface IProps {
  cover?: boolean;
  label?: string;
  height?: number | string;
  locale: Locale;
  className?: string;
}

const Root = styled.div<Pick<IProps, "cover">>`
  ${(props) => props.cover && cover()};
  z-index: ${ZIndexes.Loader};
  background-color: ${(props) => transparentize(0.7, background(props))};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Centerer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Text = styled.div`
  font-style: italic;
  margin-bottom: 16px;
  color: ${content};
`;

const StyledDots = styled(Dots)`
  z-index: ${ZIndexes.Content};
`;

const UiKitLoaderCaterpillar = ({
  cover,
  label,
  height,
  locale,
  className,
}: IProps) => (
  <Root className={className} cover={cover} style={{ height }}>
    <Centerer>
      <Text>{label || tr(locale, "CHARTS::LOADING")}</Text>
      <StyledDots />
    </Centerer>
  </Root>
);

export default UiKitLoaderCaterpillar;
